<template>
  <AdminMachineList :lockedFilters="{ SupplierIdList: [$route.params.supplierId] }" hideSupplierFilter />
</template>


<script>
import AdminMachineList from "@/views/admin/machines/AdminMachineList.vue";


export default {
  name: "ViewSupplierMachineList",
  props: {},
  components: {
    AdminMachineList,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>